/**
 * Centralized date-related labels for date pickers and validators
 * Uses Angular i18n $localize function for internationalization
 */

export const DATE_LABELS = {
  // Placeholders
  PLACEHOLDER: $localize`TT.MM.JJJJ`,

  // Validation errors
  REQUIRED: $localize`Dieses Feld ist erforderlich`,
  INVALID_FORMAT: $localize`Ungültiges Datum. Bitte verwenden Sie das Format TT.MM.JJJJ (z.B. 01.01.2025).`,
} as const;
